import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Cell } from "recharts";

const currencyFmt = (v) => `${(v / 1000).toFixed(0)}k€`;

function ChartTooltip({ active, payload, label }) {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-white dark:bg-slate-900 border rounded-lg shadow-lg px-3 py-2 text-xs">
      <p className="font-semibold mb-1">Año {label}</p>
      {payload.map((p) => (
        <p key={p.dataKey} style={{ color: p.color }}>
          {p.name}: {p.value?.toLocaleString("es-ES", { minimumFractionDigits: 0, maximumFractionDigits: 0 })} €
        </p>
      ))}
    </div>
  );
}

/** Gasto incurrido vs subvención concedida por año, agregado de todo el portafolio I+D.
 * El año seleccionado (currentYear) se resalta con más opacidad; el resto queda atenuado. */
export function GastoSubvencionPorAnioChart({ rows, currentYear, height = 260 }) {
  if (!rows?.length) return null;

  return (
    <div className="w-full" data-testid="gasto-subvencion-por-anio-chart">
      <div className="text-xs uppercase tracking-widest text-muted-foreground font-semibold mb-2">
        Gasto incurrido vs subvención concedida por año · todo el portafolio I+D
      </div>
      <ResponsiveContainer width="100%" height={height}>
        <BarChart data={rows} margin={{ top: 8, right: 8, left: 8, bottom: 8 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" vertical={false} />
          <XAxis dataKey="year" tick={{ fontSize: 11, fill: "#64748b" }} />
          <YAxis tickFormatter={currencyFmt} tick={{ fontSize: 11, fill: "#64748b" }} width={48} />
          <Tooltip content={<ChartTooltip />} />
          <Legend wrapperStyle={{ fontSize: 12 }} />
          <Bar dataKey="incurred" name="Incurrido" radius={[3, 3, 0, 0]}>
            {rows.map((r, i) => (
              <Cell key={i} fill="#dc2626" opacity={r.year === currentYear ? 1 : 0.35} />
            ))}
          </Bar>
          <Bar dataKey="external" name="Concedido" radius={[3, 3, 0, 0]}>
            {rows.map((r, i) => (
              <Cell key={i} fill="#d97706" opacity={r.year === currentYear ? 1 : 0.35} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
      <div className="text-[10px] text-muted-foreground mt-1">
        El año seleccionado ({currentYear}) se resalta; el resto se muestra atenuado como referencia de tendencia.
      </div>
    </div>
  );
}
